import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import moment from 'moment';
import {provideMomentDateAdapter} from '@angular/material-moment-adapter';

export class DateRangePickerDialogContext {
  title = 'Select Date Range';
  startDatePlaceholder = 'Start Date';
  endDatePlaceholder = 'End Date';
  cancelText = 'Cancel';
  applyText = 'Apply';
  initialStartDate: Date = null;
  initialEndDate: Date = null;
}

export class DateRangePickerDto {
  startDate: Date;
  endDate: Date;
}

@Component({
  selector: 'terra-date-range-picker-dialog',
  templateUrl: './date-range-picker-dialog.component.html',
  styleUrls: ['./date-range-picker-dialog.component.scss'],
  providers: [provideMomentDateAdapter(undefined, {useUtc:true})]
})
export class DateRangePickerDialogComponent implements OnInit {
  pageForm: UntypedFormGroup;
  endDateMin: Date;
  startDateMax: Date;

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<DateRangePickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public context: DateRangePickerDialogContext
  ) {
  }

  ngOnInit() {
    this.startDateMax = this.context.initialEndDate;
    this.endDateMin = this.context.initialStartDate;
    this.pageForm = this.fb.group({
      startDate: [this.context.initialStartDate, Validators.required],
      endDate: [this.context.initialEndDate, Validators.required]
    });
  }

  apply() {
    if (this.pageForm.invalid) {
      return;
    }

    this.dialogRef.close(this.generateResult());
  }

  setStartDateMax(value: Date) {
    this.startDateMax = moment(value).toDate();
  }

  setEndDateMin(value: Date) {
    this.endDateMin = moment(value).toDate();
  }

  generateResult() {
    const formValues = this.pageForm.getRawValue();
    const res = new DateRangePickerDto();
    res.startDate = formValues.startDate;
    const endDateLastSecond =  moment(formValues.endDate).add(1, 'day').subtract(1, 'second').toDate();
    res.endDate = endDateLastSecond;
    return res;
  }
}
